import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e88d66c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-title" }

import { toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionTitle',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props

const { title } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(title)), 1))
}
}

})